import { render } from "./ListeModeleNotificationPage.vue?vue&type=template&id=dba089d6&ts=true"
import script from "./ListeModeleNotificationPage.vue?vue&type=script&lang=ts"
export * from "./ListeModeleNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__